import api from '@/security/api'
import querystring from 'querystring'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const findAll = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/reply?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de respostas')
        })
}

const store = (data) => {
    return api.post(`/reply`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível criar a resposta')
        })
}

const message = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/reply/message?${query}`, {})
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a mensagem')
        })
}

const blacklist = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.post(`/reply/blacklist?${query}`, {})
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os dados do contato')
        })
}

const contact = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/reply/blacklist?${query}`, {})
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os dados do contato')
        })
}

export default {
    findAll,
    store,
    blacklist,
    contact,
    message
}
